<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                facilityForm: () => import('../forms/FacilityForm'),
                memberForm: () => import('../forms/MemberForm'),
                containerFileForm: () => import('../forms/ContainerFileForm'),
                fields: [
                    { type: 'autocomplete', text: 'Member', value: 'memberId', rules: [v => !!v || 'Member is required'], isRequired: true, form: () => import('./MemberForm'), apiMethod: 'Members', claim: 'Members' },
                    { type: 'text', text: 'Container Number', value: 'containerNumber', rules: [v => !!v || 'Container Number is required', v => !(v && v.length > 50) || 'Container Number must be less than 50 characters'], isRequired: true, maxLength: 50 },
                    { type: 'text', text: 'Batch Number', value: 'batchNumber', rules: [v => !(v && v.length > 100) || 'Batch Number must be less than 100 characters'], maxLength: 100 },
                    { type: 'number', text: 'Volume In Litres', value: 'volumeInLitres', rules: [] },
                    { type: 'number', text: 'Weight In Kilograms', value: 'weightInKilograms', rules: [] },
                    { type: 'autocomplete', text: 'Facility', value: 'facilityId', rules: [], form: () => import('./FacilityForm'), apiMethod: 'Facilities', claim: 'Facilities' },
                    { type: 'checkbox', text: 'Is Filled', value: 'isFilled', rules: [v => (v !== null && v !== '') || 'Is Filled is required'], isRequired: true },
                    { type: 'checkbox', text: 'Is Created By Packer', value: 'isCreatedByPacker', rules: [v => (v !== null && v !== '') || 'Is Created By Packer is required'], isRequired: true },
                    { type: 'files', text: 'Files', value: 'fileIds', parentColumnName: 'containerId', form: () => import('../forms/ContainerFileForm') }
                ],
                apiMethod: 'Containers',
                formTitle: 'Container',
            }
        },
    };
</script>
